export type MentionKind = "dash" | "insight";

export function getMentionQueryAtCaret(
  text: string,
  caretIndex: number
): { start: number; end: number; query: string } | null {
  if (caretIndex < 0) return null;
  const beforeCaret = text.slice(0, caretIndex);
  const atIndex = beforeCaret.lastIndexOf("@");
  if (atIndex === -1) return null;

  if (atIndex > 0) {
    const charBefore = beforeCaret[atIndex - 1];
    if (charBefore && !/\s/.test(charBefore)) {
      return null;
    }
  }

  const query = beforeCaret.slice(atIndex + 1);
  if (/\s/.test(query)) {
    return null;
  }

  return { start: atIndex, end: caretIndex, query };
}

export function removeMentionQuery(
  text: string,
  start: number,
  end: number
): string {
  const next = `${text.slice(0, start)}${text.slice(end)}`;
  return next.replace(/[ \t]{2,}/g, " ").trimStart();
}
